import classNames from 'classnames';
import Avatar from 'modules/common/components/Avatar';
import Tooltip from 'modules/common/components/Tooltip';
import RolesPlanBadge from 'modules/Marketing/components/RolesPlanBadge';
import type { User } from 'modules/User/interfaces';
import React from 'react';
import { MdCampaign as IconAmbassador, MdBusiness as IconCompany, MdPersonSearch as IconHighlightedOpenToSource } from 'react-icons/md';
import { RxStarFilled as IconHighlighted } from 'react-icons/rx';
import BadgeHolidayTooltip from './BadgeHolidayTooltip';

type HeadHunterAvatarProps = {
  user: User;
  withCompany?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

const HeadHunterAvatar: React.FC<HeadHunterAvatarProps> = ({ children, className, withCompany = true, user, ...props }) => {
  const highlighted = user?.isTop;
  const highlightedOpenToSource = user?.openToSource;

  return (
    <div className="relative">
      <div className={classNames('relative flex items-center gap-1', className)} {...props}>
        <div className="relative flex items-center">
          <Avatar
            size={6}
            name={user?.name}
            image={user?.image}
            bordered={highlighted || highlightedOpenToSource}
            borderColor={highlightedOpenToSource ? 'accent' : highlighted ? 'primary' : undefined}
          />

          {highlightedOpenToSource && (
            <Tooltip
              placement="bottom"
              trigger={['click', 'hover']}
              overlayClassName="opacity-100"
              overlay={
                <div>
                  <strong>Dispo pour sourcer !</strong>
                </div>
              }
            >
              <span className="absolute -top-2 -left-2 cursor-help">
                <IconHighlightedOpenToSource className="text-accent h-4 w-4 " />
              </span>
            </Tooltip>
          )}
          {highlighted && (
            <Tooltip
              placement="bottom"
              trigger={['click', 'hover']}
              overlayClassName="opacity-100"
              overlay={
                <div>
                  <strong>Top Headlinker</strong>
                </div>
              }
            >
              <span className="absolute -top-2 left-4 cursor-help">
                <IconHighlighted className="text-primary h-4 w-4 stroke-white stroke-1" />
              </span>
            </Tooltip>
          )}
        </div>
        <RolesPlanBadge roles={user?.roles} className="absolute top-0 -right-2 -translate-y-2/3 opacity-80" size="xs" />
        {user?.name}
        {user?.ambassadorFor && (
          <Tooltip
            placement="bottom"
            trigger={['click', 'hover']}
            overlayClassName="opacity-100"
            overlay={
              <div>
                Ambassadeur pour <strong>{user?.ambassadorFor}</strong>
              </div>
            }
          >
            <span className="cursor-help">
              <IconAmbassador className="text-accent h-6 w-6 " />
            </span>
          </Tooltip>
        )}
      </div>
      {withCompany && (
        <small className="flex gap-1 items-center">
          <IconCompany />
          <span className="block truncate w-36">{user?.title}</span>
        </small>
      )}
      <BadgeHolidayTooltip user={user} />
    </div>
  );
};

export default HeadHunterAvatar;
